import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators, State } from '../../state/index';
import { AppState, HubTraining, KioskTraining, OrderManagementTraining, ScanningTraining, SmartShelvesTraining, getTrainingForUserRole, UserTraining, UserRole, ExpiryManagementTraining } from '../../models';
import './LearninHome.css';
import TrainingCard from '../TrainingCard/TrainingCard';
import { TrainingModule } from '../../models'

  export function trainingForModule(module: TrainingModule) {
  switch (module) {
    case TrainingModule.Kiosk:
      return {currentTraining: KioskTraining}
    case TrainingModule.SmartShelves:
      return {currentTraining: SmartShelvesTraining}
    case TrainingModule.Hub:
      return {currentTraining: HubTraining}
    case TrainingModule.ScanningSutures:
      return {currentTraining: ScanningTraining}
    case TrainingModule.OrderManagement:
      return {currentTraining: OrderManagementTraining}
    case TrainingModule.ExpiryManagement:
      return {currentTraining: ExpiryManagementTraining}
    default:
      return {currentTraining: KioskTraining}
  }
}

interface LearninHomeProps {
  className?: string
}

const LearninHome: FC<LearninHomeProps> = ({className}: LearninHomeProps) => {
  const dispatch = useDispatch()
  const { appState, role } = useSelector((state: State) => state)

  useEffect(() => {
    setTimeout(() => {
      if (appState !== AppState.SubsquentLoad) {
        const { updateAppState } = bindActionCreators(actionCreators, dispatch)
        updateAppState(AppState.SubsquentLoad)
      }
    }, 3000)
  }, [dispatch, appState])

  const userTraining: UserTraining = getTrainingForUserRole(role as UserRole)
  const requiredCards = userTraining.required.map((module) => {
    return <TrainingCard 
              key={module} 
              module={module}
            />
  })
  const optionalCards = userTraining.optional?.map((module) => {
    return <TrainingCard 
              key={module} 
              module={module}
              small={true}
            />
  })

  return (
    <div className={`LearninHome${className !== null ? ` ${className}` : ''}`}>
      <div className="title">AITA™ Learning</div>
      <div className="trainingContent">
        <div className="recommended">RECOMMENDED TRAINING</div>
        <div className="trainingCardContainer">
          <div className="requiredCards">
            {requiredCards}
          </div>
          {userTraining.optional &&
          <>
            <div className="optional">OPTIONAL TRAINING</div>
            <div className='optionalCards'>
              {optionalCards}
            </div>
          </>
          }
        </div>
      </div>
      
    </div>
)};

export default LearninHome;
